module.exports = __webpack_public_path__ + "img/hr-tree-06-b-trunk.ec79b1e8.png";